/*
 * @Description:
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2021-12-04 13:51:00
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-01-24 17:13:16
 */
import axios from "axios";
import { Message } from "element-ui";
const TOKEN_KEY = "op-token";
const REFRESH_TOKEN_KEY = "op-refresh-token";
import router from "@/router";

function refreshToken() {
  // instance是当前request.js中已创建的axios实例
  return instance
    .post("/login/refreshToken", {
      refreshToken: localStorage.getItem(REFRESH_TOKEN_KEY),
    })
    .then((res) => {
      const { token, refreshToken } = res.data;
      if (token) {
        localStorage.setItem(TOKEN_KEY, token);
      }
      if (refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
      }
      return res;
    });
}

// 创建一个axios实例
const instance = axios.create({
  baseURL: "/pro",
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 是否正在刷新的标记
let isRefreshing = false;
// 重试队列，每一项将是一个待执行的函数形式
let requests = [];

instance.interceptors.request.use(
  (config) => {
    if (localStorage.getItem(TOKEN_KEY)) {
      config.headers["X-Token"] = localStorage.getItem(TOKEN_KEY);
    }
    return config;
  },
  (error) => {
    console.log("错误的传参", "fail");
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    const { code } = response.data;
    if (code === 1007) {
      const config = response.config;
      if (!isRefreshing) {
        isRefreshing = true;
        return refreshToken()
          .then((res) => {
            const { token } = res.data;
            instance.defaults.headers["X-Token"] = token;
            config.headers["X-Token"] = token;
            config.baseURL = "";
            // 已经刷新了token，将所有队列中的请求进行重试
            requests.forEach((cb) => cb(token));
            requests = [];
            return instance(config);
          })
          .catch((res) => {
            console.error("refreshtoken error =>", res);
          })
          .finally(() => {
            isRefreshing = false;
          });
      } else {
        // 正在刷新token，将返回一个未执行resolve的promise
        return new Promise((resolve) => {
          // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
          requests.push((token) => {
            config.baseURL = "";
            config.headers["X-Token"] = token;
            resolve(instance(config));
          });
        });
      }
    } else if (code === 1010 || code === 1006) {
      //refreshToken过期，需要重新登陆
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(REFRESH_TOKEN_KEY);
      router.push({
        name: "login",
      });
    }
    return response.data;
  },
  (error) => {
    // if (error.response.status === 401) {
    //   Message({
    //     message: "没有相关权限",
    //     type: "error",
    //     duration: 5 * 1000,
    //   });
    //   localStorage.removeItem(TOKEN_KEY);
    //   localStorage.removeItem(REFRESH_TOKEN_KEY);
    //   router.push({
    //     name: "login",
    //   });
    // }
    Message({
      message: error.response.data.msg || error.message,
      type: "error",
      duration: 5 * 1000,
    });
    switch (error.response.data.code) {
      case 1006:
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        router.push({
          name: "login",
        });
    }
    return Promise.reject(error);
  }
);

export function fetch(url, params, config, { beforeFetch, afterFetch } = {}) {
  return new Promise((resolve, reject) => {
    //删除空属性
    for (var key in params) {
      if (params[key] === "" || (params[key] && params[key].length === 0)) {
        delete params[key];
      }
    }
    if (typeof beforeFetch === "function") beforeFetch(instance);
    instance
      .post(url, params, config)
      .then(
        (response) => {
          if (typeof afterFetch === "function") afterFetch(instance);
          if (response) resolve(response);
        },
        (err) => {
          if (typeof afterFetch === "function") afterFetch(instance);
          console.log(err);
          reject(err);
        }
      )
      .catch((error) => {
        if (typeof afterFetch === "function") afterFetch(instance);
        console.log(error);
        reject(error);
      });
  });
}
export function fetchGet(url, params, config) {
  return new Promise((resolve, reject) => {
    let finalUrl = url;
    let index = 0;
    if (params) {
      finalUrl += "?";
      for (let key in params) {
        if (params[key] === "") {
          continue;
        }
        if (index === 0) {
          finalUrl += key + "=" + params[key];
        } else {
          finalUrl += "&" + key + "=" + params[key];
        }
        index++;
      }
    }
    instance
      .get(finalUrl, config)
      .then(
        (response) => {
          if (response) resolve(response);
        },
        (err) => {
          console.log(err);
          reject(err);
        }
      )
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export default instance;
